
import { useCallback,  useContext,  useEffect, useState } from 'react';
import LoadingSpinner from '../../UI/Loading/LoadingSpinner';

import FormHandler from './FormHandler/FormHandler';
import UserContext from '../../store/UserContext';
import i18n from '../../i18n';
import ModalFormContext from '../../store/ModalFormContext';
import useForm from './use-form';

const BritgeForm = ({url, multiple_form, returnTo, savedForm, saveHook, changeForm, processFormCallback = ()=>{}, ordering=false, disappear=false  }) =>{
  const [formMeta, setFormMeta] = useState({})
  const formContext = useContext(ModalFormContext)
  const [savedAddForm, setSavedAddForm] = useState(null)
  const {currentForms:forms, dispatchForms} = formContext

  const [newFormUrl, setNewFormUrl] = useState(null)
  const [hidden, setHidden] = useState(false)
  const userContext = useContext(UserContext)

  const handleSaveHook = useCallback((data, index) => {
    if(saveHook){
      saveHook(data, index)
    }
    const formsList = Array.isArray(data) ? data : null
    const succeeded = formsList
      ? formsList.every((form) => form.success || form.valid)
      : Boolean(data && data.success)
    if(disappear && succeeded){
      setHidden(true)
      window.setTimeout(() => {
        window.location.reload()
      }, 500)
    }
  }, [saveHook, disappear])

  const processForm = useCallback((data, reset) => {
      var title = null;
      if(data.title){
        title = data.title
      }
      if(title){
        formContext.setModalForm(prev => ({...prev, form_title:title}))
      }
      if(data['success']){  
        handleSaveHook(data)
        userContext.setContextReload(data.context_reload)
      }
      else{
        setFormMeta(data)
        if(reset){
          dispatchForms({type:'RESET_FORM'})
        }
        if(data.forms){
          if(formContext.form_id){
            var formIndex = forms.filter( (form) => form.form_id === formContext.form_id)
            if(formIndex.length > 0){
              formIndex = formIndex[0].index
              dispatchForms({type:'REPLACE_FORM', forms: data.forms, index: formIndex})
            }
            else{
              dispatchForms({type:'APPEND_FORM', forms:data.forms})
            }
            formContext.setModalForm( modalForm => ({...modalForm, form_id:null}));
          }
          else{
            dispatchForms({type:'APPEND_FORM', forms:data.forms})
          }
          processFormCallback(data.forms)
        }
        setNewFormUrl(data['add_new_form'])
      }
  }, [forms, handleSaveHook, processFormCallback])  

  const {isLoading : formLoading, error : formError, sendRequest : getForm} = useForm(processForm)
  const {isLoading : addFormLoading, error : addFormError, sendRequest : saveAddForm} = useForm(data => setSavedAddForm(data.forms[0]))

  useEffect(() => {
    setSavedAddForm(null)
    saveAddForm({url:newFormUrl, json:true}, false)
  }, [newFormUrl])

  const addForm = useCallback( (data) => {
    if(savedAddForm){
      dispatchForms({type:'APPEND_FORM', forms:[{...savedAddForm, form_id:null}]})
    }
  }, [savedAddForm])

  // Retrieve Form
  useEffect( () => {
    if(url){
      if(!formContext.form_id){
        dispatchForms({type:'RESET_FORM'})
      }
      setTimeout(
        ()=>getForm({url:url, json:true}, !formContext.form_id),
        100
      )
    }
  },[url])

  var error_loading = (formError) ? 
          <div className={`mt-2 alert ${[401, 403, 404].includes(formError) ? "alert-warning" : "alert-danger"} text-center mx-2`}>{formError}</div> 
          : (formLoading  && forms.length === 0) ?  
            <LoadingSpinner html_class='d-flex justify-content-center'/> 
            : false

  const handleButtonClick = useCallback( (data) => {
    if(changeForm){
      changeForm(data.target.dataset.url)
    }
  }, [changeForm])

  // bind handler
  useEffect(() => {
    var buttons = document.querySelectorAll('.form-change-button')
    buttons.forEach((element) => {
      element.addEventListener("click", handleButtonClick);
    })
  }, [formMeta, formMeta.message, handleButtonClick]);

  const formFunc = useCallback( 
    (form, index) => {
          return <FormHandler
            key={form.form_id || form.index}
            form_id={form.form_id}
            index={index}
            formIndex={form.index}
            forms={forms}
            form={form}
            dispatchForms={dispatchForms}
            classes="rest-form"
            url={url} 
            returnTo={returnTo} 
            savedForm={savedForm} 
            saveHook={handleSaveHook} 
            changeForm={changeForm}
            multiple_form={multiple_form}
        /> 
    } , [forms, dispatchForms, url, returnTo, savedForm, handleSaveHook, changeForm, multiple_form])

  const getStepTargetUrl = useCallback((stepKey) => {
    const targetForm = formContext.forms.find((form) => (
      form.object === formMeta.object &&
      form.action === stepKey 
    ))

    if(!targetForm?.form_url){
      return null
    }
    if( targetForm.form_url.includes('<pk>')){
      if(formMeta.pk){
        return targetForm.form_url.replace('<pk>', formMeta.pk)
      }
      return null
    }
    return targetForm.form_url
  }, [formContext.forms, formMeta.object, forms])

  const handleStepClick = useCallback((stepKey) => {
    const targetUrl = getStepTargetUrl(stepKey)
    if(!targetUrl){
      return
    }

    if(changeForm){
      changeForm(targetUrl)
      return
    }

    dispatchForms({type:'RESET_FORM'})
    getForm({url:targetUrl, json:true}, true)
  }, [changeForm, dispatchForms, getForm, getStepTargetUrl])

  const formSteps = formMeta.form_steps
    ? Object.entries(formMeta.form_steps).reduce((steps, [stepKey, step]) => {
        const targetUrl = getStepTargetUrl(stepKey)
        console.log(stepKey, targetUrl)
        if(targetUrl){
          steps.push([stepKey, step, targetUrl])
        }
        return steps
      }, [])
    : []
  const currentStepKey = formMeta.action
  const currentStepIndex = formSteps.findIndex(([stepKey]) => stepKey === currentStepKey)

  if(hidden){
    return null
  }

  if(error_loading){
    return error_loading
  }

  return (
    <>
      <div className="form-meta d-flex flex-column py-1">
        {formSteps.length > 0 && (
          <div className="d-flex flex-wrap justify-content-center align-items-start my-1 px-3">
            {formSteps.map(([stepKey, step, targetUrl], index) => {
              const isDone = currentStepIndex > -1 && index < currentStepIndex
              const isActive = currentStepKey === stepKey
              const bulletClass = isDone
                ? 'text-white bg-success border border-success'
                : isActive
                  ? 'text-white bg-primary border border-primary'
                  : 'text-secondary bg-white border border-secondary'
              const textClass = isDone
                ? 'fw-semibold'
                : isActive
                  ? 'fw-semibold text-primary'
                  : 'text-secondary'
              const lineClass = currentStepIndex > -1 && index < currentStepIndex
                ? 'bg-success'
                : 'bg-secondary-subtle'

              return (
                <div key={`${stepKey}-${index}`} className="d-flex align-items-start flex-grow-1" style={{ minWidth: '7rem' }}>
                  <button
                    type="button"
                    className="btn btn-link d-flex flex-column align-items-center text-center p-0 text-decoration-none flex-shrink-0"
                    onClick={() => handleStepClick(stepKey)}
                  >
                    <span
                      className={`d-inline-flex align-items-center justify-content-center rounded-circle mb-1 ${bulletClass}`}
                      style={{ width: '1.5rem', height: '1.5rem', lineHeight: 1 }}
                    >
                      {step.icon ? (
                        <span
                          className="d-inline-flex align-items-center justify-content-center"
                          style={{ width: '1rem', height: '1rem' }}
                          dangerouslySetInnerHTML={{ __html: step.icon }}
                        />
                      ) : (
                        <span>&bull;</span>
                      )}
                    </span>
                    <small className={textClass}>{step.name}</small>
                  </button>
                  {index < formSteps.length - 1 && (
                    <div className="flex-grow-1 px-2 pt-3">
                      <div className={`rounded-pill ${lineClass}`} style={{ height: '2px', width: '100%' }} />
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}
        {formMeta.message ? <div className="form-message" > <div className="d-flex flex-column overflow-auto" dangerouslySetInnerHTML={{ __html: formMeta.message }} /> </div> : ''}
        {
          savedAddForm && (
              <a type='button' onClick={addForm} className="btn btn-sm btn-outline-primary mx-auto mb-1" style={{'top': '-15px'}}>
                + {i18n.t('Add another')}
              </a>
            ) 
        }
      </div>
      <div className={`forms-wrapper d-flex flex-column mt-2 px-3 `}>
        { (ordering === true) ?  forms.toReversed().map(formFunc) : forms.map(formFunc) }
      </div>
      {formMeta.bottom_message &&
        <div className='text-center mt-3' dangerouslySetInnerHTML={{ __html: formMeta.bottom_message }} >
        </div>
      }
    </>
  );
}

export default BritgeForm

